import { useBadgingTranslation } from '../../../../ui/hooks';
import { PageHeaderWithImage } from '@juvare/common-web-ui/PageHeader';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import badgesHeaderImage from '../../../../assets/badgesHeaderImage.svg';
export const BadgePageHeader = () => {
    const { t } = useBadgingTranslation();
    return (React.createElement(PageHeaderWithImage, { gradient: 'cyan-dark', title: t('badges.badgesPanel.title'), image: badgesHeaderImage, imageAlt: t('badges.badgesPanel.title') }));
};
